import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";
import BackButton from "./BackButton";
import { usePwaInstall } from "../context/PwaInstallContext";
import { Smartphone } from "lucide-react";

export default function AppShell() {
  const location = useLocation();
  const { canInstall, standalone, openManually } = usePwaInstall();
  // Home is the app's root — no Back control there.
  const showBack = location.pathname !== "/";
  // Reset scroll on every route change so users land at the top of each
  // page (Profile, Coach, etc.) instead of wherever the previous page was
  // scrolled to.
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="min-h-screen text-[#2E2E2E]">
      <main className="max-w-2xl mx-auto px-4 sm:px-6 pb-32 pt-6">
        {showBack && (
          <div className="mb-3 -ml-1.5" data-testid="appshell-back-slot">
            <BackButton />
          </div>
        )}
        <Outlet />
        <div
          data-testid="appshell-footer-links"
          className="mt-12 text-center text-xs text-[#6B6B6B] flex flex-wrap justify-center gap-x-4 gap-y-1"
        >
          {!standalone && canInstall && (
            <>
              <button
                type="button"
                data-testid="footer-save-to-phone"
                onClick={openManually}
                className="hover:text-[#4F6F52] inline-flex items-center gap-1"
              >
                <Smartphone size={12} /> Save to My Phone
              </button>
              <span className="text-[#DCE5DB]">·</span>
            </>
          )}
          <Link
            to="/sms"
            data-testid="appshell-sms-link"
            className="hover:text-[#4F6F52]"
          >
            SMS Updates
          </Link>
          <span className="text-[#DCE5DB]">·</span>
          <Link to="/privacy" className="hover:text-[#4F6F52]">
            Privacy
          </Link>
          <span className="text-[#DCE5DB]">·</span>
          <Link to="/terms" className="hover:text-[#4F6F52]">
            Terms
          </Link>
        </div>
      </main>
      <BottomNav />
    </div>
  );
}
